// Maximum number of characters for different fields
export const MAX_LENGTH = {
    title: 256,
    groupName: 200,
}

// Maximum file sizes in MB
export const MAX_FILE_SIZE = {
    file: 2048,
    audio: 4096,
    attachment: 250,
    image: 5,
}

export const FILE_TYPE = {
    file: {
        accept: '.pdf,.csv,.png,.jpg,.doc,.docx,.xls,.xlsx,.ppt,.pptx',
        maxSize: MAX_FILE_SIZE.file,
    },
    audio: {
        accept: '.mp3,.m4a,.mp4',
        maxSize: MAX_FILE_SIZE.audio,
    },
    image: {
        accept: 'image/*',
        maxSize: MAX_FILE_SIZE.image,
    },
}

// Global regex patterns
export const REGEX = {
    email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    colorHex: /^#[0-9A-F]{6}$/i,
    slug: /^[-a-zA-Z0-9_]+$/,
    slugInputChar: /^[a-zA-Z0-9 _-]$/,
    metaKey: /^(Control|Alt|Meta|Shift)$/,
    navKey: /^(Arrow(Up|Down|Left|Right)|Tab)$/,
    editKey: /^(Backspace|Delete)$/,
}

/**
 * ID of the element that marks the start of the content. This can be used to
 * scroll to the start of the content when needed.
 */
export const START_OF_CONTENT_ELEMENT_ID = 'start-of-content'
export const START_OF_GROUP_CONTENT_ELEMENT_ID = 'start-of-group-content'

export const USER_ACTION = {
    Chat: 'chat',
    VideoCall: 'video-call',
} as const

// ----------------------------------------------------------------------------
// Video Player
// ----------------------------------------------------------------------------

const VIMEO_REGEX =
    /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_-]+)?/i

const YOUTUBE_REGEX =
    /^(https?:\/\/)?((www\.)?(youtube(-nocookie)?|youtube.googleapis)\.com.*(v\/|v=|vi=|vi\/|e\/|embed\/|user\/.*\/u\/\d+\/)|youtu\.be\/)([_0-9a-z-]+)/i

const KALTURA_REGEX = /https?:\/\/videoleren.nvwa.nl(.*?)(?="|$)/i

const BLUE_BILLYWIG_REGEX =
    /https?:\/\/(.*?)\.bbvms.com\/view\/(.*?)\/(.*?)\.html/i

export const VIDEO_PLATFORM = {
    Youtube: 'youtube',
    Vimeo: 'vimeo',
    Kaltura: 'kaltura',
    BlueBillywig: 'blue_billywig',
} as const

export const VIDEO_PLATFORM_DISPLAY_NAME = {
    Vimeo: 'Vimeo',
    Youtube: 'YouTube',
    Kaltura: 'Kaltura',
    BlueBillywig: 'Blue Billywig',
} as const

export type VideoPlatform = (typeof VIDEO_PLATFORM)[keyof typeof VIDEO_PLATFORM]

export const VIDEO_PLATFORM_REGEX = {
    Vimeo: VIMEO_REGEX,
    Youtube: YOUTUBE_REGEX,
    Kaltura: KALTURA_REGEX,
    BlueBillywig: BLUE_BILLYWIG_REGEX,
} as const
